import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useMemo } from 'react';
import { useCurrentLocale, useLocaleAlternatives } from '../../../../../locales/useTranslator';
import { getLocaleName, isValidLocale } from '../../../../../locales/localeTypes';
import { Surface, NativeSelect } from '@milanote/roma';
import globeIcon from './Globe Icon.svg';
import './LanguageSwitcher.scss';
var Icon = function Icon() {
  return /*#__PURE__*/React.createElement("img", {
    src: globeIcon,
    className: "color-white",
    style: {
      opacity: 0.5
    },
    "aria-hidden": "true",
    role: "presentation"
  });
};
export var LanguageSwitcher = function LanguageSwitcher() {
  var alternatives = useLocaleAlternatives();
  var currentLocale = useCurrentLocale();
  var _React$useState = React.useState(currentLocale),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selection = _React$useState2[0],
    setSelection = _React$useState2[1];
  var options = useMemo(function () {
    return [currentLocale].concat(_toConsumableArray(alternatives)).filter(isValidLocale).sort(function (a, b) {
      return a.localeCompare(b);
    }).map(function (locale) {
      return {
        id: locale,
        label: getLocaleName(locale)
      };
    });
  }, [alternatives, currentLocale]);
  var onLocaleSelected = useCallback(function (e) {
    var selectedLocale = e.target.value;
    if (selectedLocale === currentLocale) return;

    // we'll navigate away immediately, but it looks odd to not update the selection
    setSelection(selectedLocale);

    // Use URL object to preserve query params
    var url = new URL(window.location.href);
    url.searchParams.set('localeSwitch', '1'); // Suppress locale redirect (see infra/src/cloudfront/localeRedirect)
    if (selectedLocale === 'en') {
      url.pathname = '/';
    } else {
      url.pathname = "/".concat(selectedLocale);
    }
    window.location.href = url.toString();
  }, [currentLocale]);
  if (alternatives.length === 0) {
    return null; // Don't render the switcher if there aren't any available translations
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "LanguageSwitcher"
  }, /*#__PURE__*/React.createElement(Surface, {
    surface: "dark"
  }, /*#__PURE__*/React.createElement(NativeSelect, {
    value: selection,
    onChange: onLocaleSelected,
    leadingIcon: Icon,
    items: options
  })));
};